/* eslint-disable @typescript-eslint/no-misused-promises */
import { ThemeToggle } from "../components/theme-toggle/theme-toggle";
import FeatherIcon from "feather-icons-react";
import { Link, NavLink, Outlet, useNavigate, useParams } from "react-router";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { SubmitHandler, useForm } from "react-hook-form";

interface ISearchForm {
  name: string;
}

export default function DefaultLayout() {
  const { login, logout, isAuthenticated } = useKindeAuth();
  const { name } = useParams();
  const { register, handleSubmit } = useForm<ISearchForm>({
    defaultValues: { name },
  });
  const navigate = useNavigate();

  const onSubmitSearch: SubmitHandler<ISearchForm> = async ({ name }) => {
    await navigate(`search/${name}`);
  };

  return (
    <>
      <div className="ms-menu">
        <Link className="ms-menu-logo" to={"/"}>
          <img src="/favicon.ico" />
        </Link>
        <nav className="ms-menu-link">
          <input type="checkbox" id="ms-menu-toggle" />
          <label htmlFor="ms-menu-toggle" className="ms-menu-icon">
            <FeatherIcon icon="menu" />
          </label>
          <ul>
            <li>
              <NavLink to={"/"}>Home</NavLink>
            </li>
            <li>
              <NavLink to={"/abundant-cards"}>Abundant Cards</NavLink>
            </li>
            {!isAuthenticated && (
              <li>
                <a href="#" onClick={() => login()}>
                  Login
                </a>
              </li>
            )}
            {isAuthenticated && (
              <>
                <li>
                  <NavLink to={"/add-set"}>Add set</NavLink>
                </li>
                <li>
                  <a href="#" onClick={() => logout()}>
                    Logout
                  </a>
                </li>
              </>
            )}
            <li>
              <form onSubmit={handleSubmit(onSubmitSearch)}>
                <input
                  type="text"
                  placeholder="Search: e.g. Pikachu"
                  {...register("name")}
                />
                <button style={{ display: "none" }} type="submit">
                  Search
                </button>
              </form>
            </li>
            <li>
              <ThemeToggle />
            </li>
          </ul>
        </nav>
      </div>
      <div className="content">
        <Outlet />
      </div>
    </>
  );
}
